import React from 'react'
import { ICONO_CATALOGOS } from '../../utils/constants'




// las imagenes pueden ser combinaciones de las imagenes, puetas en array de una constante
const Card = ({ data, handleClick, textoBoton, id, value }) => {

const textos = (opcion) => {
  const opciones = {
    "3" : () => "¡El diseño gráfico permite expresar tu creatividad y dar vida a tus ideas!, ya sea que estés experimentando con colores o fotografías, cada paso es una oportunidad para aprender algo nuevo y mejorar tus habilidades",
    "4" : () => "¡Aprender inglés es la llave para comunicarte con personas de todo el mundo, acceder a una vasta cantidad de conocimiento y entretenimiento en su forma original. Cada nueva palabra que aprendes es un paso más hacia la fluidez ",
    "1" : () => "¡Aprender Microsoft Office es una aventura llena de posibilidades!, podrás crear documentos impresionantes, analizar datos como un profesional y presentar tus ideas con confianza                                                ",
    "2" : () => "La programación es como tener superpoderes digitales al alcance de tus dedos. Cada línea de código que escribes puede transformar ideas en realidad, resolver problemas complejos y crear cosas que nunca antes existían          ",
  }
  return opciones[opcion]()
}


  return (

    <div className={"bg-primarioMira rounded-md m-2 content-center"}>
      <div className={"grid content-center /mt-2"}>
        <p className={"text-white mx-auto font-medium text-2xl"}>Cursos disponibles</p>
      </div>

      <div role="list" className="mt-3 grid grid-cols-1 /gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-2 xl:grid-cols-4 mx-3 mb-4 gap-2">
        {data && data.map((project, index) => (
          <div key={index} className={"flex flex-col  /shadow-white justify-between max-w-sm p-2 xl:p-4 border border-gray-200 /bg-primarioMira bg-gray-800 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 text-center elementFadeIn"}>

            <div className='flex flex-row /bg-gray-700 bg-secundarioMira shadow shadow-white px-4 py-12 rounded-md'>
              {
                ICONO_CATALOGOS[project?.IdCatalogo].map((element, index) => (
                  <img
                    // width="full" 
                    // height="14"
                    className={"w-[20%] mx-auto rounded"}
                    src={`./img/cursos/${ICONO_CATALOGOS[project?.IdCatalogo][index]}`}
                    alt="visual-studio-code-2019" />
                ))
              }
            </div>
            <div className={" text-start shadow-sm shadow-white text-md text-white dark:text-white bg-primarioMira p-4 -mt-8 rounded-md mx-2"}>
                <p className="font-medium">{`${project[value]}`}</p>
                <p className="mb-2 text-sm text-gray-400">{`${textos(project[id])}`}</p>
                <div className='flex flex-row'>
                     <a 
                       href="#" 
                       className="inline-flex items-center /px-3 py-2 text-sm font-medium /text-center text-azulBrillanteMira hover:underline /bg-azulBrillanteMira rounded-lg /hover:bg-secundario /hover:shadow-white shadow-sm "
                       onClick={() => handleClick(project[id])}
                       >{`Ver ${textoBoton}`}
                     </a>
                     <svg className="my-auto animate-pulse rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                       <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                     </svg>
                 </div>
            </div>

          </div>
        ))}
      </div>
      
    </div>
  )
}

export default Card